module.exports = __webpack_public_path__ + "img/pleasure-icon-2.6cd27d6f.svg";